var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"flex flex-col"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }